import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" {...props}>
      <g
        data-name="consultant"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={8}
      >
        <path
          d="M28 105.35v-25.1s.05-60 68-60 68 60 68 60v19.1M164 113.25s.25 47-44 47"
          stroke="#333"
        />
        <path
          d="M40 76.35h0a12 12 0 0112 12v23.9a12 12 0 01-12 12h0a12 12 0 01-12-12v-23.9a12 12 0 0112-12z"
          stroke="#333"
        />
        <path
          d="M120 160.25h0a12 12 0 01-12 12H84a12 12 0 01-12-12h0a12 12 0 0112-12h24a12 12 0 0112 12z"
          stroke="#e60000"
        />
        <path
          d="M152 76.35h0a12 12 0 0112 12v23.9a12 12 0 01-12 12h0a12 12 0 01-12-12v-23.9a12 12 0 0112-12z"
          stroke="#333"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
